import { computed, type ComputedRef, type MaybeRefOrGetter, toValue } from "vue";
import { useI18n } from "vue-i18n";

const primarySubtag = (languageTag: string) => languageTag.split(/[-_]/)[0].toLowerCase();

/**
 * The `lang` a Nadia reply's container needs, or undefined when it inherits the page's (WCAG 3.1.2).
 *
 * Nadia replies in the user's chat language, which is set independently of the UI locale
 * (BRA-1045), so an English interface can carry Spanish replies. Only the primary subtag is
 * compared: a regional or pseudo-locale UI ("en-XA") still reads an "en" reply correctly.
 */
export function replyLangFor(replyLanguageCode: string | null | undefined, uiLocale: string): string | undefined {
    if (!replyLanguageCode) {
        return undefined;
    }
    return primarySubtag(replyLanguageCode) === primarySubtag(uiLocale) ? undefined : replyLanguageCode;
}

export function useReplyLang(replyLanguageCode: MaybeRefOrGetter<string | null | undefined>): ComputedRef<string | undefined> {
    const { locale } = useI18n();
    return computed(() => replyLangFor(toValue(replyLanguageCode), locale.value));
}
